import { ReactElement } from 'react'

interface MenuItemWrapperProps {
  children: ReactElement
  url: string
}

const MenuItemWrapper = ({ children }: MenuItemWrapperProps) => {
  // Leave this component as a wrapper for future use cases - previously used for tutorial tootips
  return children
}

export default MenuItemWrapper
